import { Badge } from '@mui/material';
import { BoltRounded } from '@mui/icons-material';
import { styled } from '@mui/system';
import React from 'react';

function OptimizationBadge({ optimizationCount }) {

    return (
        <StyledBadge badgeContent={optimizationCount} color='primary' anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
        }}>
            <BoltRounded />
        </StyledBadge>
    )
}

const StyledBadge = styled(Badge)(() => ({
    '& .MuiBadge-badge': {
        height: '15px',
        minWidth: '15px',
        borderRadius: '10px',
        left: 3,
        padding: 0,
    }
}));

export default OptimizationBadge;